import { useMemo } from "react";
import { useAbsenceInfiniteQuery } from "../../../../entities/absence";
import { useDebounce } from "../../../../shared/hooks/useDebounce";
import {
  mapFiltersFormToApi,
  TimeManagementFiltersForm,
} from "./timeManagementFilters.types";
import {
  toTimeManagementFiltersForm,
  useTimeManagementFiltersParams,
} from "./useTimeManagementFiltersParams";

const PAGE_LIMIT = 20;

export function useTimeManagementFilters() {
  const [params, setParams] = useTimeManagementFiltersParams();

  const filters = useMemo<TimeManagementFiltersForm>(
    () => toTimeManagementFiltersForm(params),
    [params],
  );

  const debouncedFilters = useDebounce(filters, 400);

  const apiFilters = useMemo(
    () => mapFiltersFormToApi(debouncedFilters, PAGE_LIMIT),
    [debouncedFilters],
  );

  const query = useAbsenceInfiniteQuery(apiFilters);

  return {
    filters,
    setFilters: setParams,
    ...query,
  };
}
